import { createRoot } from "react-dom/client";
import { initSentry, initWebVitals } from "./sentry";
import App from "./App.tsx";
import "./theme/fonts.css";

// Initialize Sentry before React
initSentry();

// Initialize Web Vitals monitoring (reports LCP, INP, CLS, TTFB to Sentry)
initWebVitals();

createRoot(document.getElementById("root")!).render(<App />);
